import { render, staticRenderFns } from "./TreatmentCreatedEmailTemplate.vue?vue&type=template&id=4935c7a1&scoped=true"
import script from "./TreatmentCreatedEmailTemplate.vue?vue&type=script&lang=js"
export * from "./TreatmentCreatedEmailTemplate.vue?vue&type=script&lang=js"
import style0 from "./TreatmentCreatedEmailTemplate.vue?vue&type=style&index=0&id=4935c7a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4935c7a1",
  null
  
)

export default component.exports